import Headline, { HeadlineFlag } from "../model/headline";
const tips = {
    0: [
        new Headline("New Arts & Crafts Store Opens on 31st Street", ["crafts", "local shopping"], 3, 3, [], "craftstore"),
        new Headline("Airport Expansion Plan Stalled, Mayor Blames Council for Funding Issues", ["airport", "city politics"], 4, 3, [], "airport-funding"),
        new Headline("Can the Eagles Finally Beat the Tigers?", ["football"], 2, 4),
    ],
    1: [
        new Headline("Airport Contractor Claims City 3 Months Behind on Bills", ["airport", "city politics"], 2, 3, [], "airport-funding"),
        new Headline("View Power Outages In Your Neighborhood", [], 2, 1),
        new Headline("31 Can't-Miss Deals at 31st Street Crafts!", ["crafts", "local shopping"], 2, 4, [], "craftstore"),
    ],
    2: [
        new Headline("Traveling Soon? Don't Miss These 3 New Shops at the Airport", ["airport"], 2, 4),
        new Headline("Does Your Child Have a GitHub Account They're Not Telling You About?", ["parents"], 1, 4, [HeadlineFlag.FEARMONGERING]),
        new Headline("\"Utterly Ridiculous\": Students Describe Problems with University Fees", ["students"], 3, 3, []),
    ],
    3: [
        new Headline("Man, 31, Arrested For Trying To Bring \"Pet\" Alligator On Plane", [], 3, 5, [HeadlineFlag.HILARIOUS]),
        new Headline("The History and Future of the Local Airport", ["airport"], 5, 3),
        new Headline("Recent Court Proceedings", ["law"], 3, 1),
    ],
    4: [
        new Headline("Local Teachers' Union Threatens Strike Over Low Wages", ["city politics", "parents"], 3, 3, [], "teachers-strike"),
        new Headline("Airport: Sheetrock Left Outside Overnight in Thunderstorm", ["city politics"], 3, 3, [], "airport-funding"),
        new Headline("Is Cryptocurrency the Future of Banking?", ["cryptocurrency"], 2, 4),
    ],
    5: [
        new Headline("What Should You Do if Your Teenager is Experimenting With \"Linux\"?", ["parents"], 1, 4, [HeadlineFlag.FEARMONGERING]),
        new Headline("Eagles Lose Third Game in a Row", ["football"], 3, 3),
        new Headline("No School Next Week? Teachers Demand More Salary, Less Bureaucracy", ["parents"], 4, 3, [], "teachers-strike"),
    ],
    6: [
        new Headline("Gender Reveal Party Causes Nuclear Close Call", [], 2, 4, [HeadlineFlag.HILARIOUS]),
        new Headline("City Council Passes New Restrictions on Fireworks", [], 3, 3),
        new Headline("The City Wants Better Education, But Doesn't Want to Pay For It", ["parents", "city politics"], 3, 3, [], "teachers-strike"),
    ],
    7: [
        new Headline("$3.4 Million Missing in Airport Expansion Scandal", ["airport", "city politics"], 4, 3, [], "airport-funding"),
        new Headline("Thunderstorms Expected Tomorrow", ["weather"], 2, 1),
        new Headline("Study Shows Pineapple Belongs on Pizza", ["food"], 1, 3, [HeadlineFlag.INFURIATING]),
    ],
    8: [
        new Headline("Eagles Finally Win a Game!", ["football"], 2, 4),
        new Headline("Embezzlement Suspected in Airport Budget Crisis", ["airport", "city politics"], 3, 3, [], "airport-funding"),
        new Headline("No School Next Monday As Teachers Give Up On Our Kids", ["parents", "city politics"], 2, 5, [HeadlineFlag.INFLAMMATORY], "teachers-strike")
    ],
    9: [
        new Headline("Mayor Johnson Denies The Obvious In Airport Scandal", ["city politics"], 2, 4, [HeadlineFlag.INFLAMMATORY], "airport-funding"),
        new Headline("Zoo Closed Due to Ransomware Attack", [], 3, 4),
        new Headline("11 Horrible Puns to Make Your Friends Cringe", [], 2, 3),
    ],
};
const topics = {
    "crafts": {},
    "local shopping": {},
    "airport": {},
    "city politics": {},
    "parents": {},
    "weather": {},
    "students": {},
    "football": {},
    "cryptocurrency": {},
};
export { tips, topics };
